export type HeroSlideAsset = {
  id: string
  altKey?: string
  alt?: string
  png768: string
  webp480: string
  webp768: string
  webp1024: string
  width: number
  height: number
  slot?: number
}

const BASE = '/hero'

/**
 * Default homepage hero slides — Ilia-1 … Ilia-5 (correct numbering).
 * Used as fallback when the API is unavailable; live order/images come from admin.
 */
export const HERO_SLIDES: HeroSlideAsset[] = [1, 2, 3, 4, 5].map((n) => ({
  id: `ilia-${n}`,
  slot: n,
  altKey: `hero.slideAlt${n}`,
  png768: `${BASE}/Ilia-${n}-768.png`,
  webp480: `${BASE}/Ilia-${n}-480.webp`,
  webp768: `${BASE}/Ilia-${n}-768.webp`,
  webp1024: `${BASE}/Ilia-${n}-1024.webp`,
  width: 768,
  height: 960,
}))

export const HERO_SLIDE_INTERVAL_MS = 5000
export const HERO_SLIDE_TRANSITION_MS = 650
export const HERO_SLIDE_SIZES =
  '(max-width: 767px) min(92vw, 340px), (max-width: 1023px) 42vw, min(50vw, 580px)'

export type HomepageHeroSlideDto = {
  id: string
  slot: number
  position: number
  sortOrder?: number
  isActive?: boolean
  altDe: string | null
  altAr: string | null
  hasCustomImage: boolean
  imageUrl: string
  png768: string
  webp480: string
  webp768: string
  webp1024: string
  width: number
  height: number
  defaultAsset?: string
}

export function mapHeroSlideDto(
  dto: HomepageHeroSlideDto,
  locale: string,
): HeroSlideAsset {
  const alt = locale.startsWith('ar') ? dto.altAr : dto.altDe
  return {
    id: dto.id,
    slot: dto.slot,
    alt: alt || undefined,
    altKey: alt ? undefined : `hero.slideAlt${dto.slot}`,
    png768: dto.png768,
    webp480: dto.webp480,
    webp768: dto.webp768,
    webp1024: dto.webp1024,
    width: dto.width || 768,
    height: dto.height || 960,
  }
}
